<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('sidelight.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'sidelights' }">{{ $t('sidelight.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-form @submit="submitParam">
          <b-input-group size="lg">
            <b-form-select
              v-model="filter.of_category"
              style="border-color: black; color: black"
              size="lg"
            >
              <b-form-select-option value="" active>{{ $t('sidelight.list.search-bar.category-selector.hint') }}</b-form-select-option>
              <b-form-select-option value="visit">會務概況</b-form-select-option>
              <b-form-select-option value="develop-affinity">法寶結緣</b-form-select-option>
              <b-form-select-option value="hwadzan-garden">華藏園區</b-form-select-option>
              <b-form-select-option value="college">假日佛學院</b-form-select-option>
              <b-form-select-option value="course">本會課程</b-form-select-option>
              <b-form-select-option value="?">法務訊息</b-form-select-option>
            </b-form-select>
            <b-form-select
              v-model="filter.of_year"
              style="border-color: black; color: black"
              size="lg"
            >
              <b-form-select-option value="">{{ $t('sidelight.list.search-bar.year-selector.hint') }}</b-form-select-option>
              <b-form-select-option :value="n" v-for="n in years">{{ n }}年</b-form-select-option>
            </b-form-select>
            <b-input-group-append>
              <b-button type="submit" variant="primary">{{ $t('sidelight.list.search-bar.search-button.label') }}</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </div>
    </div>
    <b-overlay :show="is_loading" rounded="sm" opacity="0.6">
      <div class="row mt-3">
        <div class="col-sm-6" v-for="sidelight in sidelights">
          <b-card no-body class="overflow-hidden">
            <b-row no-gutters>
              <b-col md="6">
                <b-card-img
                  alt="Image"
                  class="rounded-0"
                  :src="getUrlOfOnePhoto(sidelight.attachments)"
                ></b-card-img>
              </b-col>
              <b-col md="6">
                <b-card-body :title="sidelight.topic">
                  <b-button
                    squared
                    target="_blank"
                    variant="outline-primary"
                    :to="{ name: 'sidelight', params: { id: sidelight.id } }"
                  >{{ $t('sidelight.list.button.more-info.label') }}</b-button>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <b-pagination
            v-model="page"
            :total-rows="total"
            :per-page="per_page"
            @change="pageChange"
            align="center"
            size="lg"
          ></b-pagination>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <b-icon icon="arrow-clockwise" font-scale="5" animation="spin-pulse"></b-icon>
        </div>
      </template>
    </b-overlay>
  </div>
</template>
<script>
import Vue from 'vue'

import lodash from 'lodash'

import { stringify } from 'query-params-helpers'
import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { CardPlugin } from 'bootstrap-vue'
import { FormPlugin } from 'bootstrap-vue'
import { FormSelectPlugin } from 'bootstrap-vue'
import { IconsPlugin } from 'bootstrap-vue'
import { InputGroupPlugin } from 'bootstrap-vue'
import { LayoutPlugin } from 'bootstrap-vue'
import { OverlayPlugin } from 'bootstrap-vue'
import { PaginationPlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

import SidelightApiService from '@/services/budaedu-api-services/sidelight-api-service.js'

Vue.use(lodash)
Vue.use(BreadcrumbPlugin)
Vue.use(ButtonPlugin)
Vue.use(CardPlugin)
Vue.use(FormPlugin)
Vue.use(FormSelectPlugin)
Vue.use(IconsPlugin)
Vue.use(InputGroupPlugin)
Vue.use(LayoutPlugin)
Vue.use(OverlayPlugin)
Vue.use(PaginationPlugin)

Vue.use(SidelightApiService)

export default {
  i18n,
  name: 'sidelights',
  props: {
    // 
  },
  data() {
    return {
      is_loading: false,
      filter: {
        of_category: '',
        of_year: ''
      },
      years: [],
      per_page: 12,
      page: 1,
      total: 0,
      sidelights: []
    }
  },
  methods: {
    submitParam(event) {
      event.preventDefault()
      this.page = 1
      this.setSidelightsAndPaging()
    },
    pageChange(page) {
      this.page = page
      this.setSidelightsAndPaging()
    },
    getUrlOfOnePhoto(attachments) {
      const photos = attachments
        .filter(item => item.category == 'photo')
        .sort((a, b) => a.name.localeCompare(b.name))

      return photos.length > 0 ? photos.shift().url : ''
    },
    async setYears() {
      this.years = await this.$sidelightApiService.getListOfOccurrenceYear()
    },
    async setSidelightsAndPaging() {
      this.is_loading = true
      this.sidelights = []
      try {
        const params = stringify({
            include: 'attachments',
            filter: lodash.pickBy(this.filter, value => value !== ''),
            per_page: this.per_page,
            page: this.page,
            order: 'take_place_date,desc|created_at,desc'
        }).substr(1)
        const items = await this.$sidelightApiService.query(params)

        this.sidelights = items.data
        this.total = items.meta.total
      } finally {
        this.is_loading = false
      }
    }
  },
  async created() {
    // alert(`Vue version : ${Vue.version}`)
    await this.setYears()
    await this.setSidelightsAndPaging()
  },
  components: {
    // 
  },
  metaInfo() {
    return {
      title: this.$t('sidelight.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
};
</script>